module.exports = __webpack_public_path__ + "static/media/info-icon.67f48119.svg";